import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';
import { GiCheckMark } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { CgDanger } from "react-icons/cg";
export default function ZclWorkerRegReport() {
    const [showList, setList] = useState([])
    function GetChequeInReport() {
        let url = config.url.BOC_URL + "zclWise";
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.zclWise);
            }
            else {
                setList([])
            }
        })
    }
    let navigate = useNavigate()
    useEffect(() => { GetChequeInReport() }, [])
    const columns = [
        {
            Header: 'S.NO',
            accessor: (row, index) => index + 1,
            Footer: 'Total',

        },
        {
            Header: 'zcl_org_name',
            accessor: (row) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "own_approved", org_id: row?.zcl_org } }) }}>{row?.zcl_org_name}</span>,
            Footer: '',

        },

        {
            Header: 'Registered on their Own',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "own_total",
                    // // Cell:  ({ row }) =>
                    //     (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "own_total"   ,zcl_org: row?.original?.zcl_org} }) }}>{row?.original?.own_total}</span>)
                    // ,
                    Footer: 'own_total',
                    tooltipmsg: 'Registered'
                },
                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "own_approved",
                    // // Cell:  ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "own_approved", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.own_approved}</span>,
                    Footer: 'own_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "own_rejected",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "own_rejected", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.own_rejected}</span>),
                    Footer: 'own_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "own_pending",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "own_pending", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.own_pending}</span>),
                    Footer: 'own_pending',
                    tooltipmsg: 'Pending'
                },
            ],
        },
        {
            Header: 'Registered By GSWS',
            accessor: 'Registered By GSWS',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "gsws_total",
                    // Cell:  ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "gsws_total", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.gsws_total} </span>,
                    Footer: 'gsws_total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "gsws_approved",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "gsws_approved", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.gsws_approved} </span>),
                    Footer: 'gsws_approved',
                    tooltipmsg: 'Approved'

                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "gsws_rejected",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "gsws_rejected", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.gsws_rejected} </span>),
                    Footer: 'gsws_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "gsws_pending",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "gsws_pending", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.gsws_pending} </span>),
                    Footer: 'gsws_pending',
                    tooltipmsg: 'Pending'
                },
            ],
            Footer: '',
        },
        {
            Header: 'Registered By Alo',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "alo_total",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "alo_total", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.alo_total} </span>),
                    Footer: 'alo_total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "alo_approved",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "alo_approved", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.alo_approved} </span>),
                    Footer: 'alo_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "alo_rejected",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "alo_rejected", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.alo_rejected} </span>),
                    Footer: 'alo_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "alo_pending",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "alo_pending", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.alo_pending}  </span>),
                    Footer: 'alo_pending',
                    tooltipmsg: 'Pending'

                },
            ],
            Footer: '',

        },
        {
            Header: 'Total',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "total",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "total", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.total} </span>),
                    Footer: 'total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "approved",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "approved", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.approved} </span>),
                    Footer: 'approved',
                    tooltipmsg: 'Approved'

                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "rejected",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "rejected", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.rejected} </span>),
                    Footer: 'rejected',
                    tooltipmsg: 'Rejected'

                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "pending",
                    // Cell:  ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/DclWiseWorkerRegReport', { state: { status: "pending", zcl_org: row?.original?.zcl_org } }) }}>{row?.original?.pending}  </span>),
                    Footer: 'pending',
                    tooltipmsg: 'Pending'

                },
            ],
            Footer: '',

        },
    ]
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Zcl Worker Registration Report" />
            <jnb.Container className="outer-page-content-container">
                <div className="table-responsive">
                    <CommonReactTable columns={columns} data={showList} showFooter="true" filename="DepartmentReport" />
                </div>
            </jnb.Container>
        </React.Fragment>
    )
}
